module.exports = __webpack_public_path__ + "img/view_6.01e5e063.jpg";